import { useState } from "react"
import type { ReactElement } from "react"

import type { MapDto } from "../../../models"
import { PageType } from "../../../redux"
import type { Breadcrumb, Chapter, LinkChapter, Project, Region, Theme } from "../../../redux"
import { IndexViewer } from "../../organisms"

export interface IIndexMapSelectorProps {
  mapSelection: Project[]
  onMapSelect: (map: Project) => void
  onShowPreview?: (map: Project) => void
}

export interface IIndexNavigationState {
  chapterId?: string
  themeId?: string
  regionId?: string
}

export function IndexMapSelector(props: IIndexMapSelectorProps): ReactElement {
  const { mapSelection, onMapSelect, onShowPreview } = props

  const [navigationState, setNavigationState] = useState<IIndexNavigationState>({})

  function navigateToChapter(chapter: Chapter | LinkChapter): void {
    setNavigationState({ chapterId: chapter.id })
  }

  function navigateToRegion(region: Region): void {
    setNavigationState({ regionId: region.id })
  }

  function navigateToTheme(theme: Theme): void {
    setNavigationState({ themeId: theme.id })
  }

  function toProject(map: MapDto): Project {
    return {
      metaDataId: map.id,
      drawings: [],
      attachments: [],
      bundles: []
    }
  }

  function onMapClicked(map: MapDto): void {
    onMapSelect(toProject(map))
  }

  function onMapPreview(map: MapDto): void {
    if (onShowPreview) onShowPreview(toProject(map))
  }

  function onReturnToPage(page: Breadcrumb): void {
    switch (page.type) {
      case PageType.Chapter:
        setNavigationState({ chapterId: page.id })
        break
      case PageType.Region:
        setNavigationState({ regionId: page.id })
        break
      case PageType.Theme:
        setNavigationState({ themeId: page.id })
        break
      case PageType.Index:
        setNavigationState({})
    }
  }

  return (
    <IndexViewer
      disableLinkChapters
      projectSelection={mapSelection}
      chapterId={navigationState.chapterId}
      regionId={navigationState.regionId}
      themeId={navigationState.themeId}
      onChapterClicked={navigateToChapter}
      onRegionClicked={navigateToRegion}
      onThemeClicked={navigateToTheme}
      onMapClicked={onMapClicked}
      onMapPreview={onMapPreview}
      returnToPage={onReturnToPage}
    />
  )
}
